import * as React from "react";
import PropTypes from "prop-types";
import { BsWifi } from "react-icons/bs";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
// import required modules
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { FreeMode } from "swiper";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import {
  multilanguage,
  loadLanguages,
  changeLanguage,
} from "redux-multilanguage";
import { connect } from "react-redux";

function RoomDetailPremium(props) {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = React.useState(0);
  const [isPopupOpen, setPopupOpen] = useState(false);

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  const handlePopupToggle = () => {
    setPopupOpen(!isPopupOpen);
  };

  const handlePopupClose = () => {
    setPopupOpen(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const images = [
    "/img/jsuite_01.webp",
    "/img/jsuite_02.webp",
    "/img/jsuite_03.webp",
    "/img/jsuite_04.webp",
  ];

  const imagesTwo = [
    "/img/fam_jsuite_01.webp",
    "/img/fam_jsuite_02.webp",
    "/img/fam_jsuite_03.webp",
    "/img/fam_jsuite_01.webp",
  ];
  const imagesThree = [
    "/img/pr_suite_01.webp",
    "/img/pr_suite_05.webp",
    "/img/pr_suite_04.webp",
    "/img/pr_suite_02.webp",
  ];

  const imagesFour = [
    "/img/presidential_01.webp",
    "/img/presidential_02.webp",
    "/img/presidential_03.webp",
    "/img/presidential_04.webp",
  ];

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <Tabs className="room_tab_detail">
        <TabList className="tab_list">
          <Tab className="tab_one_room room_tab_pink">
            <h6 className=""> {props.strings["text_332"]}</h6>
          </Tab>
          <Tab className="tab_two_room room_tab_pink">
            <h6 className="">{props.strings["text_333"]}</h6>
          </Tab>
          <Tab className="tab_three_room room_tab_pink">
            <h6 className="">{props.strings["text_334"]}</h6>
          </Tab>
          <Tab className="tab_four_room room_tab_pink">
            <h6 className="">{props.strings["text_335"]}</h6>
          </Tab>
        </TabList>
        <TabPanel>
          <div className="d-flex room_two">
            <div className="row">
              <div className="col-lg-5">
                <div>
                  <div
                    id="carouselExampleIndicators"
                    className="carousel slide carousel-fade"
                    data-mdb-ride="carousel"
                  >
                    <div className="carousel-inner mb-5">
                      {images.map((image, index) => (
                        <div
                          key={index}
                          className={`carousel-item ${
                            index === 0 ? "active" : ""
                          }`}
                          onClick={() => openLightbox(index)}
                        >
                          <img
                            src={image}
                            className="d-block w-100"
                            alt="..."
                          />
                        </div>
                      ))}
                    </div>
                    <button
                      className="carousel-control-prev"
                      type="button"
                      data-mdb-target="#carouselExampleIndicators"
                      data-mdb-slide="prev"
                    >
                      <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                      />
                      <span className="visually-hidden">Previous</span>
                    </button>
                    <button
                      className="carousel-control-next"
                      type="button"
                      data-mdb-target="#carouselExampleIndicators"
                      data-mdb-slide="next"
                    >
                      <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                      />
                      <span className="visually-hidden">Next</span>
                    </button>
                    <div
                      className="carousel-indicators"
                      
                    >
                      {images.map((image, index) => (
                        <button
                          key={index}
                          type="button"
                          data-mdb-target="#carouselExampleIndicators"
                          data-mdb-slide-to={index}
                          className={index === photoIndex ? "active" : ""}
                          aria-current={index === photoIndex ? "true" : "false"}
                          aria-label={`Slide ${index + 1}`}
                          style={{ width: 100 }}
                          onClick={() => openLightbox(index)}
                        >
                          <img
                            className="d-block w-100 "
                            src={image}
                            alt={`Slide ${index + 1}`}
                          />
                        </button>
                      ))}
                    </div>
                  </div>

                  {isOpen && (
                    <Lightbox
                      mainSrc={images[photoIndex]}
                      nextSrc={images[(photoIndex + 1) % images.length]}
                      prevSrc={
                        images[(photoIndex + images.length - 1) % images.length]
                      }
                      onCloseRequest={() => setIsOpen(false)}
                      onMovePrevRequest={() =>
                        setPhotoIndex(
                          (photoIndex + images.length - 1) % images.length
                        )
                      }
                      onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % images.length)
                      }
                    />
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                {" "}
                <h4 className="text-center "> {props.strings["imkan"]}</h4>
                <div className="room_text_section">
                  <div className="col-lg-6">
                    <p>
                      <ul>
                        <li>✔ {props.strings["text_222"]} </li>
                        <li>✔ {props.strings["text_223"]}</li>
                        <li>✔ {props.strings["text_224"]}</li>
                        <li>✔ {props.strings["text_225"]}</li>
                        <li> ✔{props.strings["text_226"]}</li>
                        <li> ✔{props.strings["text_281"]}</li>
                      </ul>
                    </p>
                  </div>
                  <div className="col-lg-6">
                    {" "}
                    <p>
                      <ul>
                        <li>✔ {props.strings["text_282"]}</li>
                        <li>✔ {props.strings["text_228"]}</li>
                        <li> ✔{props.strings["text_229"]}</li>
                        <li>✔ {props.strings["text_240"]}</li>
                        <li>✔ {props.strings["text_230"]}</li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          {" "}
          <div className="d-flex room_two_jr">
            <div className="row">
              <div className="col-lg-5">
                <div>
                  <div
                    id="carouselExampleIndicators"
                    className="carousel slide carousel-fade"
                    data-mdb-ride="carousel"
                  >
                    <div className="carousel-inner mb-5">
                      {imagesTwo.map((image, index) => (
                        <div
                          key={index}
                          className={`carousel-item ${
                            index === 0 ? "active" : ""
                          }`}
                          onClick={() => openLightbox(index)}
                        >
                          <img
                            src={image}
                            className="d-block w-100"
                            alt="..."
                          />
                        </div>
                      ))}
                    </div>
                    <button
                      className="carousel-control-prev"
                      type="button"
                      data-mdb-target="#carouselExampleIndicators"
                      data-mdb-slide="prev"
                    >
                      <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                      />
                      <span className="visually-hidden">Previous</span>
                    </button>
                    <button
                      className="carousel-control-next"
                      type="button"
                      data-mdb-target="#carouselExampleIndicators"
                      data-mdb-slide="next"
                    >
                      <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                      />
                      <span className="visually-hidden">Next</span>
                    </button>
                    <div
                      className="carousel-indicators"
                      
                    >
                      {imagesTwo.map((image, index) => (
                        <button
                          key={index}
                          type="button"
                          data-mdb-target="#carouselExampleIndicators"
                          data-mdb-slide-to={index}
                          className={index === photoIndex ? "active" : ""}
                          aria-current={index === photoIndex ? "true" : "false"}
                          aria-label={`Slide ${index + 1}`}
                          style={{ width: 100 }}
                          onClick={() => openLightbox(index)}
                        >
                          <img
                            className="d-block w-100"
                            src={image}
                            alt={`Slide ${index + 1}`}
                          />
                        </button>
                      ))}
                    </div>
                  </div>

                  {isOpen && (
                    <Lightbox
                      mainSrc={imagesTwo[photoIndex]}
                      nextSrc={imagesTwo[(photoIndex + 1) % imagesTwo.length]}
                      prevSrc={
                        imagesTwo[
                          (photoIndex + imagesTwo.length - 1) % imagesTwo.length
                        ]
                      }
                      onCloseRequest={() => setIsOpen(false)}
                      onMovePrevRequest={() =>
                        setPhotoIndex(
                          (photoIndex + imagesTwo.length - 1) % imagesTwo.length
                        )
                      }
                      onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % imagesTwo.length)
                      }
                    />
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <h4 className="text-center "> {props.strings["imkan"]}</h4>

                <div className="room_text_section">
                  <div className="col-lg-6">
                    {" "}
                    <p>
                      <ul>
                        <li>✔ {props.strings["text_222"]} </li>
                        <li>✔ {props.strings["text_328"]} </li>
                        <li>✔ {props.strings["text_329"]} </li>
                  
                        <li>✔ {props.strings["text_224"]}</li>
                        <li>✔ {props.strings["text_225"]}</li>
                        <li>✔ {props.strings["text_226"]}</li>
                      </ul>
                    </p>
                  </div>
                  <div className="col-lg-6">
                    {" "}
                    <p>
                      <ul>

                        <li>✔ {props.strings["text_228"]}</li>
                        <li>✔ {props.strings["text_281"]}</li>
                        <li>✔ {props.strings["text_282"]}</li>
                        <li>✔ {props.strings["text_239"]}</li>
                        <li> ✔{props.strings["text_240"]}</li>
                        <li>✔ {props.strings["text_230"]}</li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          {" "}
          <div className="d-flex room_suite">
            <div className="row">
              <div className="col-lg-5">
                <div>
                  <div
                    id="carouselExampleIndicators"
                    className="carousel slide carousel-fade"
                    data-mdb-ride="carousel"
                  >
                    <div className="carousel-inner mb-5">
                      {imagesThree.map((image, index) => (
                        <div
                          key={index}
                          className={`carousel-item ${
                            index === 0 ? "active" : ""
                          }`}
                          onClick={() => openLightbox(index)}
                        >
                          <img
                            src={image}
                            className="d-block w-100"
                            alt="..."
                          />
                        </div>
                      ))}
                    </div>
                    <button
                      className="carousel-control-prev"
                      type="button"
                      data-mdb-target="#carouselExampleIndicators"
                      data-mdb-slide="prev"
                    >
                      <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                      />
                      <span className="visually-hidden">Previous</span>
                    </button>
                    <button
                      className="carousel-control-next"
                      type="button"
                      data-mdb-target="#carouselExampleIndicators"
                      data-mdb-slide="next"
                    >
                      <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                      />
                      <span className="visually-hidden">Next</span>
                    </button>
                    <div
                      className="carousel-indicators"
                      
                    >
                      {imagesThree.map((image, index) => (
                        <button
                          key={index}
                          type="button"
                          data-mdb-target="#carouselExampleIndicators"
                          data-mdb-slide-to={index}
                          className={index === photoIndex ? "active" : ""}
                          aria-current={index === photoIndex ? "true" : "false"}
                          aria-label={`Slide ${index + 1}`}
                          style={{ width: 100 }}
                          onClick={() => openLightbox(index)}
                        >
                          <img
                            className="d-block w-100"
                            src={image}
                            alt={`Slide ${index + 1}`}
                          />
                        </button>
                      ))}
                    </div>
                  </div>

                  {isOpen && (
                    <Lightbox
                      mainSrc={imagesThree[photoIndex]}
                      nextSrc={
                        imagesThree[(photoIndex + 1) % imagesThree.length]
                      }
                      prevSrc={
                        imagesThree[
                          (photoIndex + imagesThree.length - 1) %
                            imagesThree.length
                        ]
                      }
                      onCloseRequest={() => setIsOpen(false)}
                      onMovePrevRequest={() =>
                        setPhotoIndex(
                          (photoIndex + imagesThree.length - 1) %
                            imagesThree.length
                        )
                      }
                      onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % imagesThree.length)
                      }
                    />
                  )}
                </div>
              </div>{" "}
              <div className="col-lg-6">
                <h4 className="text-center "> {props.strings["imkan"]}</h4>

                <div className="room_text_section">
                  <div className="col-lg-6">
                    {" "}
                    <p>
                      <ul>
                        <li>✔ {props.strings["text_231"]}</li>
                        <li>✔ {props.strings["text_188"]}</li>
                        <li>✔ {props.strings["text_331"]}</li>
                        <li>✔ {props.strings["text_330"]}</li>
                        <li>✔ {props.strings["text_245"]}</li>
                        <li>✔ {props.strings["text_224"]}</li>
                        <li>✔ {props.strings["text_225"]}</li>
                        <li>✔ {props.strings["text_226"]}</li>

                      </ul>
                    </p>
                  </div>
                  <div className="col-lg-6">
                    {" "}
                    <p>
                      <ul>
                       
                        <li> ✔{props.strings["text_228"]}</li>
                        <li> ✔{props.strings["text_239"]}</li>
                        <li>✔ {props.strings["text_230"]}</li>
                        <li>✔ {props.strings["text_285"]}</li>
                        <li>✔ {props.strings["text_282"]}</li>
                        <li>✔ {props.strings["text_286"]}</li>
                        <li>✔ {props.strings["text_284"]}</li>
                       
                      </ul>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="d-flex room_king">
            <div className="row">
              <div className="col-lg-5">
                <div>
                  <div
                    id="carouselExampleIndicators"
                    className="carousel slide carousel-fade"
                    data-mdb-ride="carousel"
                  >
                    <div className="carousel-inner mb-5">
                      {imagesFour.map((image, index) => (
                        <div
                          key={index}
                          className={`carousel-item ${
                            index === 0 ? "active" : ""
                          }`}
                          onClick={() => openLightbox(index)}
                        >
                          <img
                            src={image}
                            className="d-block w-100"
                            alt="..."
                          />
                        </div>
                      ))}
                    </div>
                    <button
                      className="carousel-control-prev"
                      type="button"
                      data-mdb-target="#carouselExampleIndicators"
                      data-mdb-slide="prev"
                    >
                      <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                      />
                      <span className="visually-hidden">Previous</span>
                    </button>
                    <button
                      className="carousel-control-next"
                      type="button"
                      data-mdb-target="#carouselExampleIndicators"
                      data-mdb-slide="next"
                    >
                      <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                      />
                      <span className="visually-hidden">Next</span>
                    </button>
                    <div
                      className="carousel-indicators"
                      
                    >
                      {imagesFour.map((image, index) => (
                        <button
                          key={index}
                          type="button"
                          data-mdb-target="#carouselExampleIndicators"
                          data-mdb-slide-to={index}
                          className={index === photoIndex ? "active" : ""}
                          aria-current={index === photoIndex ? "true" : "false"}
                          aria-label={`Slide ${index + 1}`}
                          style={{ width: 100 }}
                          onClick={() => openLightbox(index)}
                        >
                          <img
                            className="d-block w-100"
                            src={image}
                            alt={`Slide ${index + 1}`}
                          />
                        </button>
                      ))}
                    </div>
                  </div>

                  {isOpen && (
                    <Lightbox
                      mainSrc={imagesFour[photoIndex]}
                      nextSrc={imagesFour[(photoIndex + 1) % imagesFour.length]}
                      prevSrc={
                        imagesFour[
                          (photoIndex + imagesFour.length - 1) %
                            imagesFour.length
                        ]
                      }
                      onCloseRequest={() => setIsOpen(false)}
                      onMovePrevRequest={() =>
                        setPhotoIndex(
                          (photoIndex + imagesFour.length - 1) %
                            imagesFour.length
                        )
                      }
                      onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % imagesFour.length)
                      }
                    />
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <h4 className="text-center "> {props.strings["imkan"]}</h4>

                <div className="room_text_section">
                  <div className="col-lg-6">
                  <p>
                      <ul>
                        <li>✔ {props.strings["text_242"]}</li>
                        <li>✔ {props.strings["text_243"]}</li>
                        <li>✔ {props.strings["text_244"]}</li>
                        <li>✔ {props.strings["text_245"]}</li>
                        <li>✔ {props.strings["text_246"]}</li>
                        <li>✔ {props.strings["text_247"]}</li>
                        <li>✔ {props.strings["text_250"]}</li>
                        <li>✔ {props.strings["text_285"]}</li>
                        <li>✔ {props.strings["text_249"]}</li>
                      </ul>
                    </p>
                  </div>
                  <div className="col-lg-6">
                    {" "}
                    <p>
                      <ul>
                        <li>✔ {props.strings["text_234"]}</li>
                        <li>✔ {props.strings["text_219"]}</li>
                        <li>✔ {props.strings["text_220"]}</li>
                        <li>✔ {props.strings["text_195"]}</li>
                        <li>✔ {props.strings["text_253"]}</li>
                        <li>✔ {props.strings["text_282"]}</li>
                        <li>✔ {props.strings["text_286"]}</li>
                        <li>✔ {props.strings["text_284"]}</li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabPanel>
      </Tabs>
    </>
  );
}

RoomDetailPremium.propTypes = {
  dispatch: PropTypes.func,
  strings: PropTypes.object,
  currentLanguageCode: PropTypes.string,
};
export default connect()(multilanguage(RoomDetailPremium));
